import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchAllTestSeriesBySlug, fetchBlogBySlug } from "../../services/api";
import TestSeriesNormal from "./TestSeriesNormal";
import TestSeriesTabs from "./TestSeriesTabs";
import { BlogDetails } from "../../types/blogDetails";

interface Test {
  _id: string;
  test_name: string;
  no_of_questions: number;
  test_pay_type: string;
  blog_title_post_slug: string;
  blog_title_post_name: string;
  blog_title_post_id: string;
  timing: string;
  subject?: string;
}
//type Status = "started" | "submitted" | undefined;

const TestSeries = () => {
  const { slug } = useParams();
  const [blogDetails, setBlogDetails] = useState<BlogDetails | null>(null);
  const [tests, setTests] = useState<Test[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (slug) {
      // axios
      //   .get(`http://localhost:5000/api/v1/online-tests/${slug}`)
      fetchBlogBySlug(slug)
        .then(async (response) => {
          console.log("BLOG DETAILS", response.data);
          setBlogDetails(response.data);
        })
        .catch((error) => {
          console.error(error);
          setLoading(false);
        });

      fetchAllTestSeriesBySlug(slug)
        .then(async (res) => {
          setTests(res.data);
          const token = localStorage.getItem("token");
          const user = localStorage.getItem("user");
          if (token && user) {
            setLoading(false);
          }
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        });
    }
  }, [slug]);

  if (loading || !blogDetails) return null;

  // 🔥 DECISION POINT
  if (blogDetails?.is_tab === 1 && blogDetails.tabs?.length) {
    return <TestSeriesTabs blogDetails={blogDetails} tests={tests}/>;
  }

  return <TestSeriesNormal blogDetails={blogDetails} tests={tests}/>;
};

export default TestSeries;

